<template>
  <div class="text-slider">
    <slick ref="slick" :options="slickOptions" >
      <div class="text-slider__item">
        <h3 class="text-slider__title">Some Ads Information</h3>
        <p class="text-slider__desc">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>
      </div>
      <div class="text-slider__item">
        <h3 class="text-slider__title">Some Ads Information 2</h3>
        <p class="text-slider__desc">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>
      </div>
      <div class="text-slider__item">
        <h3 class="text-slider__title">Some Ads Information 3</h3>
        <p class="text-slider__desc">It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal distribution of letters, as opposed to using 'Content here, content here', making it look like readable English.</p>
      </div>
    </slick>
    <div class="text-slider__controls">
      <button class="text-slider__arrow text-slider__arrow--left" @click="prev">Prev</button>
      <button class="text-slider__arrow text-slider__arrow--right" @click="next">Next</button>
    </div>
  </div>
</template>

<script>
import Slick from 'vue-slick'

export default {
  components: {
    Slick
  },
  data () {
    return {
      slickOptions: {
        slidesToShow: 1,
        arrows: false
      }
    }
  },
  methods: {
    next () {
      this.$refs.slick.next()
    },
    prev () {
      this.$refs.slick.prev()
    },
    reInit () {
      this.$nextTick(() => {
        this.$refs.slick.reSlick()
      })
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/advertiser/plugins/slider.vue